import { getPitchChangeForRoofs } from 'components/ManualToolModal/util';
import { useRefs } from 'contexts/RefContext';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { updateRoofPitch } from 'components/DisplayRoofData/api';
import { appToast } from 'components/Basic/CustomToast';

export default function useEditPitch() {
	const { uuid, allRoofSegs } = useSelector((state: RootState) => state.roofData.data);
	const { roofIndexes } = useSelector((state: RootState) => state.toolNewPostions.data);
	const { konvaRef } = useRefs();

	return useMutation(
		async () => {
			if (!konvaRef?.current) return;
			const updatedRoofSegs = getPitchChangeForRoofs(konvaRef.current, roofIndexes, allRoofSegs);
			if (!updatedRoofSegs.length) throw new Error('E_NO_SEGMENTS_TO_SAVE');
			await updateRoofPitch(uuid, updatedRoofSegs);
		},
		{
			mutationKey: 'update-roof-pitch',
			onError(error: AxiosError) {
				if (error.message === 'E_NO_SEGMENTS_TO_SAVE') return;
				appToast.error('Something went wrong, please try again');
			},
		});

}
